<div
  class="card overflow-hidden hover:bg-hover trans-ease-out cursor-pointer"
  [attr.data-contact-card-fullname]="contact?.fullName"
  (click)="linkToContact()"
  matRipple
>
  <!-- Header: Avatar + Nom (centré) - Cliquable -->
  <div class="relative bg-gradient-to-br from-primary-50 to-primary-100 p-6 text-center">
    <!-- Actions en haut à droite -->
    <div class="absolute top-2 right-2 flex space-x-1 z-10" (click)="$event.stopPropagation()">
      <button
        mat-icon-button
        (click)="onArchive.emit()"
        *ngIf="canArchive"
        [permissionBlock]="updatePermission"
        matTooltip="Archiver ce contact"
        class="action-btn"
      >
        <mat-icon class="text-orange-600" [icIcon]="icArchive"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="onUnarchive.emit()"
        *ngIf="canUnarchive"
        [permissionBlock]="updatePermission"
        matTooltip="Restaurer ce contact (désarchiver)"
        class="action-btn"
      >
        <mat-icon class="text-green-600" [icIcon]="icRestore"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="onEdit.emit()"
        *ngIf="canUpdate"
        [permissionBlock]="updatePermission"
        matTooltip="Modifier ce contact"
        class="action-btn"
      >
        <mat-icon [icIcon]="icEdit"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="onDelete.emit()"
        *ngIf="canDelete"
        [permissionBlock]="deletePermission"
        matTooltip="Supprimer ce contact"
        class="action-btn"
      >
        <mat-icon class="text-red" [icIcon]="icDelete"></mat-icon>
      </button>
    </div>

    <!-- Avatar -->
    <div
      class="avatar h-20 w-20 mx-auto bg-primary flex justify-center items-center text-white text-2xl tracking-wide rounded-full shadow-md"
    >
      {{ contactInitial }}
    </div>

    <!-- Nom -->
    <h2 class="text-lg font-semibold mt-3 mb-0 text-gray-800">{{ contact?.fullName | titlecase }}</h2>
  </div>

  <!-- Body: Informations (alignées à gauche) -->
  <div class="p-4">
    <!-- Types d'acteurs -->
    <div *ngIf="contact?.contactType?.length > 0" class="mb-3">
      <div class="flex items-start">
        <ic-icon [icon]="icPerson" class="text-secondary mr-2 flex-shrink-0 mt-0.5" size="18px"></ic-icon>
        <div class="flex-1">
          <div class="text-xs font-bold text-gray-700 mb-1">Types d'acteurs</div>
          <div class="text-sm text-gray-800">
            <span *ngFor="let type of contact?.contactType; let last = last">
              {{ type.label }}
              <span *ngIf="!last">,</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Types de contact fournisseur -->
    <div *ngIf="contact?.contactTypes?.length > 0" class="mb-3">
      <div class="flex items-start">
        <ic-icon [icon]="icContacts" class="text-secondary mr-2 flex-shrink-0 mt-0.5" size="18px"></ic-icon>
        <div class="flex-1">
          <div class="text-xs font-bold text-gray-700 mb-1">Contact fournisseur</div>
          <div class="text-sm text-gray-800">
            <span *ngFor="let type of contact?.contactTypes; let last = last">
              {{ type.label }}
              <span *ngIf="!last">,</span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Séparateur si types présents -->
    <mat-divider
      *ngIf="contact?.contactType?.length > 0 || contact?.contactTypes?.length > 0"
      class="my-3"
    ></mat-divider>

    <!-- Email -->
    <div class="flex items-start mb-2">
      <ic-icon [icon]="icMail" class="text-secondary mr-2 flex-shrink-0 mt-0.5" size="18px"></ic-icon>
      <span class="text-sm text-gray-700 break-all">{{ contact?.email }}</span>
    </div>

    <!-- Téléphone -->
    <div class="flex items-start">
      <ic-icon [icon]="icPhone" class="text-secondary mr-2 flex-shrink-0 mt-0.5" size="18px"></ic-icon>
      <span class="text-sm text-gray-700">{{ displayPhoneNumbers(contact?.phoneNumbers) || 'Non renseigné' }}</span>
    </div>

    <ng-content></ng-content>
  </div>

  <!--    <div-->
  <!--            *hasPermission="allPermissions; op: 'OR'"-->
  <!--            class="bg-app-bar p-2"-->
  <!--            fxLayout="row"-->
  <!--            fxLayoutAlign="space-around center"-->
  <!--    >-->
  <!--        <a-->
  <!--                *hasPermission="callPermission"-->
  <!--                href="tel:{{ contact?.mobileNumber }}"-->
  <!--                class="text-secondary"-->
  <!--                mat-icon-button-->
  <!--                type="button"-->
  <!--        >-->
  <!--            <mat-icon [icIcon]="icPhone"></mat-icon>-->
  <!--        </a>-->

  <!--        <a-->
  <!--                *hasPermission="sendPermission"-->
  <!--                href="mailto:{{ contact?.email }}"-->
  <!--                class="text-secondary"-->
  <!--                mat-icon-button-->
  <!--                type="button"-->
  <!--        >-->
  <!--            <mat-icon [icIcon]="icMail"></mat-icon>-->
  <!--        </a>-->

  <!--        <ng-container *ngIf="showAction" matColumnDef="actions">-->
  <!--            <div style="text-align: right">-->
  <!--                <div>-->
  <!--                    <button-->
  <!--                            [matMenuTriggerFor]="columnActionMenu"-->
  <!--                            mat-icon-button-->
  <!--                            type="button"-->
  <!--                    >-->
  <!--                        <mat-icon-->
  <!--                                [icIcon]="icMoreVert"-->
  <!--                                matTooltip="actions"-->
  <!--                                [matTooltipShowDelay]="1500"-->
  <!--                        ></mat-icon>-->
  <!--                    </button>-->
  <!--                </div>-->
  <!--            </div>-->
  <!--        </ng-container>-->

  <!--        <mat-menu #columnActionMenu="matMenu" xPosition="before" yPosition="below">-->
  <!--            <ng-container *hasPermission="updatePermission">-->
  <!--                <button *ngIf="canUpdate" class="mat-menu-item" (click)="onEdit.emit()">-->
  <!--                    <mat-icon [icIcon]="icEdit"></mat-icon>-->
  <!--                    Modifier-->
  <!--                </button>-->
  <!--            </ng-container>-->
  <!--            <ng-container *hasPermission="deletePermission">-->
  <!--                <button-->
  <!--                        *ngIf="canDelete"-->
  <!--                        class="mat-menu-item"-->
  <!--                        (click)="onDelete.emit()"-->
  <!--                >-->
  <!--                    <mat-icon [icIcon]="icDelete"></mat-icon>-->
  <!--                    Supprimer-->
  <!--                </button>-->
  <!--            </ng-container>-->
  <!--        </mat-menu>-->
  <!--    </div>-->
</div>
